'use client';

import React from 'react';
import { TasticProps } from 'frontastic/tastics/types';
import FAQSection, {FAQSectionProps} from 'components/commercetools-ui/organisms/content/faq-section';

const FAQSectionTasticSecond = ({ data }: TasticProps<FAQSectionProps>) => {
    return <FAQSection data={data?.data?.dataSource} />;
};

export default FAQSectionTasticSecond;